import React from 'react';

import I18n from '~/src/common/services/I18n';
import { ProductDetailed } from '~/src/common/typings/product';
import { getAttributeValue } from '~/src/common/utils/product';

import { Header, Label, Value, Key, AdditionalInformationContainer } from './layout';

interface SectionProps {
  className?: string;
  attributes: ProductDetailed['attributes'];
}

const ProductAdditionalInformation = ({ className, attributes }: SectionProps) => {
  return (
    <AdditionalInformationContainer className={className}>
      <Header>{I18n.t('view-product-screen.additionnal-infos')}</Header>

      {attributes?.map(({ key, label, value, valueUnit }) => (
        <Label key={`${key}_${value as string | number}_label`}>
          <Key>{label || key}</Key>
          <Value
            key={key}
            dangerouslySetInnerHTML={{
              __html: getAttributeValue({ value, valueUnit }),
            }}
          />
        </Label>
      ))}
    </AdditionalInformationContainer>
  );
};

export default ProductAdditionalInformation;
